import React from "react";
import { currencyFormate } from "../Date_Formate_Utilitiy/Index";

const Total_Amount_Row_Sell_Purchase = ({ data }) => {
  return (
    <div className="col-12" style={{ height: 19.5 }}>
      {/* Mirror exact same column structure as item rows for vertical alignment */}
      <div className="row" style={{ height: 19.5 }}>
        <div className="col-1 m-0 p-0" style={{ width: "3%" }}></div>
        <div className="col-4 m-0 p-0"></div>
        <div className="col-1 m-0 p-0" style={{ width: "5%" }}></div>
        <div className="col-2 m-0 p-0"></div>
        <div className="col-1 m-0 p-0"></div>
        <div className="col-1 m-0 p-0"></div>
        <div className="col-1 m-0 p-0" style={{ width: "10.1%" }}></div>
        <div className="col-1 m-0 p-0" style={{ width: "5%" }}></div>
        <div
          className="col m-0 p-0 pe-1 border_2_2px_top border_2_1px_bottom border_2_1px_left text-end"
          style={{ fontSize: 13, height: 19.5 }}
        >
          {data?.total_amount_item
            ? currencyFormate(data.total_amount_item)
            : ""}
        </div>
      </div>
    </div>
  );
};

export default Total_Amount_Row_Sell_Purchase;
